export default "\n<div class=\"search-con\">\n  <img src=\"/code-online/assets/images/p1.jpg\" width=\"300px\" height=\"300px\" alt=\"p\" />\n</div>\n"